<template>
    <div class="review-stars">
        <img v-for="i in rateNumber" :key="i" src="../../assets/images/star.svg" class="star-icon" />
    </div>
</template>

<script>

export default {
    name: "ReviewStars",
    props: {
        rateNumber: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            
        };
    },
    mounted: function () { },
    computed: {},
    methods: {
       
    },
};
</script>
